import CuratedLists from './CuratedLists';
import FeaturedBikes from './FeaturedBikes';
import FindPartsForYourBikeCTA from './FindPartsForYourBikeCTA';
import GetTheAppCTA from './GetTheAppCTA';
import Highlights from './Highlights';
import MainBanner from './MainBanner';
import SeeWhatOurCustomersSay from './SeeWhatOurCustomersSay';
import SellersToFollow from './SellersToFollow';
import SellOnMxLockerCTA from './SellOnMxLockerCTA';
import HomepageHeader from './Home/components/HomepageHeader';
import SaleBanner from './SaleBanner';
import MTBCTA from './MTBCTA';

export {
  CuratedLists,
  FeaturedBikes,
  FindPartsForYourBikeCTA,
  GetTheAppCTA,
  Highlights,
  MainBanner,
  SeeWhatOurCustomersSay,
  SellersToFollow,
  SellOnMxLockerCTA,
  HomepageHeader,
  SaleBanner,
  MTBCTA,
};
